import { MutationTree } from "vuex";
import { AIAssessmentState } from "./interfaces";

const mutations: MutationTree<AIAssessmentState> = {
  SET_LOADING(state, payload: boolean) {
    state.isLoading = payload;
  },
  SET_LOADING_CONTEXT(state, payload: AIAssessmentState["loadingContext"]) {
    state.loadingContext = payload;
  },
  SET_ERROR(state, payload: string | null) {
    state.error = payload;
  },
  SET_SESSION_ID(state, payload: string | null) {
    state.sessionId = payload;
  },
  APPEND_CHAT(
    state,
    payload: { type: "ai" | "user" | "system"; text: string }
  ) {
    state.chatLog.push({ ...payload, at: Date.now() });
  },
  SET_QUESTIONS(state, payload) {
    state.questions = payload || [];
  },
  SET_ASSESSMENT_DATA(state, payload) {
    state.assessmentData = payload;
  },
  SET_RESULT_MODAL(state, payload: boolean) {
    state.showResultModal = payload;
  },
  SET_EDIT_MODE(state, payload: boolean) {
    state.isEditMode = payload;
  },
  SET_EDITING_QUESTION_INDEX(state, payload: number | null) {
    state.editingQuestionIndex = payload;
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  UPDATE_QUESTION(state, payload: { index: number; question: any }) {
    if (state.assessmentData && state.assessmentData.questions[payload.index]) {
      state.assessmentData.questions[payload.index] = payload.question;
    }
  },
  UPDATE_LAST_AI_MESSAGE(state, payload: string) {
    // Find the last AI message in chatLog and update it
    for (let i = state.chatLog.length - 1; i >= 0; i--) {
      if (state.chatLog[i].type === "ai") {
        try {
          // Try to parse as JSON to extract content from token format
          const data = JSON.parse(payload);
          if (data.content) {
            state.chatLog[i].text = state.chatLog[i].text + data.content;
          } else {
            state.chatLog[i].text = state.chatLog[i].text + payload;
          }
        } catch (error) {
          // If not JSON, use payload as is
          state.chatLog[i].text = state.chatLog[i].text + payload;
        }
        break;
      }
    }
  },
  REMOVE_LAST_MESSAGE(state) {
    if (state.chatLog.length > 0) {
      state.chatLog.pop();
    }
  },
  RESET(state) {
    state.isLoading = false;
    state.error = null;
    state.sessionId = null;
    state.chatLog = [];
    state.questions = [];
    state.assessmentData = null;
    state.showResultModal = false;
    state.isEditMode = false;
    state.editingQuestionIndex = null;
    state.streamingMessage = null;
  }
};

export default mutations;
